<template>
  <div>
    <div class="plan">
      <div class="t">
        信息登记详情
        <div v-if="detailShow.status == -1" class="statusShow error">
          登记驳回
        </div>
        <div v-if="detailShow.status == 0" class="statusShow waiting">
          登记中
        </div>
        <div v-if="detailShow.status == 1" class="statusShow end">已登记</div>
      </div>
      <div class="return" @click="goReturn">
        返回上一级 <img src="@/assets/img/return.png" alt="" />
      </div>
    </div>
    <div class="statusBox">
      <img
        v-if="detailShow.status == 1"
        src="@/assets/img/success.png"
        alt=""
      />
      <img v-if="detailShow.status == -1" src="@/assets/img/error.png" alt="" />
      <img v-if="detailShow.status == 0" src="@/assets/img/wait.png" alt="" />
      <div class="statusCont">
        <div class="item">
          <span class="t">审核状态：</span>
          <span class="c" v-if="detailShow.status == -1">登记驳回</span>
          <span class="c" v-if="detailShow.status == 0">登记中</span>
          <span class="c" v-if="detailShow.status == 1">登记成功</span>
        </div>
        <div class="item" v-if="detailShow.status == 1">
          <span class="t">审核时间：</span>
          <span class="c">{{ detailShow.exam_time }}</span>
        </div>
        <!--登记审核通过 只有上面两个字段 -->
        <!-- -1审核不通过 0待审核 1审核通过-->
        <!-- 登记中-->
        <div class="item" v-if="detailShow.status == 0">
          <span class="t">审核反馈：</span>
          <span class="c">您提交的信息正在审核中，请耐心等待</span>
        </div>
        <!--登记驳回-->
        <div class="item" v-if="detailShow.status == -1">
          <span class="t">驳回原因：</span>
          <span class="c">{{ detailShow.remarks }}</span>
        </div>
      </div>
    </div>
    <div class="bodyControll">
      <div class="tabControll">
        <div class="it" @click="select(1)" :class="{ active: val === 1 }">
          企业基本信息
        </div>
        <div class="it" @click="select(2)" :class="{ active: val === 2 }">
          专职专业人员信息
        </div>
        <div class="it" @click="select(3)" :class="{ active: val === 3 }">
          业绩信息
        </div>
      </div>
      <div class="contBox">
        <ZzStaffDetail v-show="val === 2" :detail="this.record_id" />
        <CompanyDetail v-show="val === 1" :detail="this.record_id" />
        <YjDetail v-show="val === 3" :detail="this.record_id" />
      </div>
    </div>
  </div>
</template>

<script>
import ZzStaffDetail from "@/components/record/ZzStaffDetail";
import CompanyDetail from "@/components/record/CompanyDetail";
import YjDetail from "@/components/record/YjDetail";
import { enterprise } from "@/api/company.js";
// import AddStaff from "@/components/addStaff";

export default {
  name: "recordDetail",
  components: {
    // AddStaff,
    ZzStaffDetail,
    CompanyDetail,
    YjDetail,
    // Step,
  },
  data() {
    return {
      val: 1,
      record_id: 0, //上一页传过来的记录id
      detailShow: {}, //详情展示
      // companyDetail: {}, //企业基本信息
    };
  },
  created() {
    // this.detail();
    let id = this.$route.query.record_id ? this.$route.query.record_id : 0;
    this.record_id = Number(id);
    console.log(typeof this.record_id);
    this.init();
  },
  methods: {
    goReturn() {
      this.$router.push({ name: "homeIndex" });
    },
    select(val) {
      this.val = val;
    },
    async init() {
      // console.log(this.record_id, "record_id---------");

      this.detailShow = await enterprise({ record_id: this.record_id });
    },
  },
};
</script>
<style lang="less" scoped>
.plan {
  height: 60px;
  background: #ffffff;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;

  .t {
    font-size: 20px;
    color: #333333;
    display: flex;
    align-items: center;

    .statusShow {
      font-size: 12px;
      color: #ffffff;
      margin-left: 8px;
      padding: 2px;
      border-radius: 2px;
    }

    .error {
      background: rgb(243, 35, 35);
    }

    .waiting {
      background: rgb(68, 150, 241);
    }

    .end {
      background: rgb(37, 162, 45);
    }
  }

  .return {
    display: flex;
    cursor: pointer;
    align-items: center;
    font-size: 14px;
    color: #4379f6;

    img {
      width: 12px;
      height: 10px;
      margin-left: 3px;
    }
  }
}

.statusBox {
  margin-top: 15px;
  background: #ffffff;
  border-radius: 2px;
  padding: 18px 58px;
  display: flex;
  align-items: center;

  img {
    width: 44px;
    height: 44px;
  }

  .statusCont {
    margin-left: 40px;

    .item {
      display: flex;
      align-items: center;
      margin-top: 10px;

      &:first-child {
        margin-top: unset;
      }

      .t {
        font-size: 12px;
        color: #999999;
      }

      .c {
        font-size: 12px;
        color: #333333;
      }
    }
  }
}

.bodyControll {
  background: #ffffff;
  border-radius: 2px;
  margin-top: 20px;
  padding-bottom: 62px;

  .tabControll {
    border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;
    padding: 15px 18px 0;

    .it {
      font-size: 14px;
      color: #333333;
      border-bottom: #fff 3px solid;
      padding-bottom: 13px;
      margin-left: 40px;
      cursor: pointer;

      &:first-child {
        margin-left: unset;
      }
    }

    .active {
      color: #4379f6;
      border-bottom: #4379f6 3px solid;
    }
  }

  .contBox {
    padding: 0 20px;
    background: #fff;
  }
}
</style>
